/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { IGetCountryRegionSuccess, IGetCountryRegionFailure } from "./CountryRegionAction";
import { COUNTRYDATA_LOAD_SUCCESS, COUNTRYDATA_LOAD_FAILURE } from "../../Constants/ActionTypes";
import { ICountryRegionDataState } from "../../Interfaces/SiteContent";

const intialState: ICountryRegionDataState = {
  countryRegions: [],
  countryRegionOptionList: [],
  countryRegionPhoneOptionList: [],
  countryRegionLoadError: "",
};

/**
 *
 * @param state
 * @param action
 */
const applyLoadCountryRegions = (
  state: ICountryRegionDataState,
  action: IGetCountryRegionSuccess
): ICountryRegionDataState => ({
  ...state,
  countryRegions: action.countryRegions,
  countryRegionOptionList: action.countryRegions.map((x) => ({
    key: x.countryRegionName,
    text: x.countryRegionName,
    id: x.countryRegionId,
  })),
  countryRegionPhoneOptionList: action.countryRegions.map((x) => ({
    key: x.countryRegionName,
    text: x.countryRegionName + " (+" + x.tapiCode + ")",
    tapi: x.tapiCode,
    id: x.countryRegionId,
  })),
});

/**
 *
 * @param state
 * @param action
 */
const applyLoadFailCountryRegions = (
  state: ICountryRegionDataState,
  action: IGetCountryRegionFailure
): ICountryRegionDataState => ({
  ...state,
  countryRegionLoadError: action.countryRegionLoadError,
});

/**
 *
 * @param state
 * @param action
 */
function countryRegionReducer(state: ICountryRegionDataState = intialState, action: any) {
  switch (action.type) {
    case COUNTRYDATA_LOAD_SUCCESS:
      return applyLoadCountryRegions(state, action);
    case COUNTRYDATA_LOAD_FAILURE:
      return applyLoadFailCountryRegions(state, action);
    default:
      return state;
  }
}

export default countryRegionReducer;
